import { Button, Table, Typography, Form, Space, Row } from "antd";
import React, { SetStateAction, useEffect, useState } from "react";
import { EditableCell, EditableRow } from "./EditTable";
import Icons from "assets/icons";
import { ColumnTypes } from "types/models/column-table-edit";
import "./TableInputAdd.scss";
import { randomId } from "helper/common";
import diagnose from "api/diagnose";
import { Notification } from "components/common";

const TableInputAdd = ({
  data,
  column,
  setData,
  isCheckbox,
  disabled,
  name,
  form,
  setTongTien,
  ...rest
}: any): JSX.Element => {
  const handleSave = (row: any, index: number) => {
    const newData = data.map((e: any) => ({ ...e, key: randomId() }));
    newData[index] = row;
    setData(newData);
  };

  const components = {
    body: {
      row: EditableRow,
      cell: EditableCell,
    },
  };

  const columns = column.map((col: any) => {
    return {
      ...col,
      onCell: (record: any, index: number) => ({
        record: data[index],
        selected: col.selected,
        dataIndex: col.dataIndex,
        title: col.title,
        options: col.options,
        onChange: col.onChange,
        index: index,
        handleSave,
        type: col.type,
        disabled: col.disabled ?? disabled,
        value: col.value,
        name: name,
        form: form,
        initRules: col.rules,
        autoFocus: col.autoFocus,
        fields: col.fields,
        hidden: col.hidden,
        setTongTien: setTongTien,
        ...col,
      }),
    };
  });

  return (
    <div className="table-prescription">
      <Table
        rowKey={(record) => record.key}
        components={components}
        // rowClassName={"editable-row-2"}
        bordered
        dataSource={data}
        columns={columns as ColumnTypes}
        {...rest}
        pagination={false}
        scroll={{ x: "100%" }}
      />
    </div>
  );
};

export default TableInputAdd;
